'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useHomepageTopBannerUpsellSlotPlan } from '#pplx/frontend/apps/ask/upsell-slots/homepage-top-banner/internal/useHomepageTopBannerUpsellSlotPlan.js';
import { useWindowsLegacyAppUpsellBannerPlan } from '#pplx/frontend/apps/ask/upsell-slots/homepage-top-banner/internal/useWindowsLegacyAppUpsellBannerPlan.js';
import { UPSELL_SLOT_ACCEPTED_LOCATIONS, UPSELL_SLOT_IDS, } from '#pplx/frontend/apps/ask/upsell-slots/UpsellSlotInventory.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
import React, { useEffect, useRef } from 'react';
const HomepageTopBanner = Dynamic(async () => {
    const { HomepageTopBanner } = await import('#pplx/frontend/apps/ask/upsell-slots/homepage-top-banner/internal/HomepageTopBanner.js');
    return { default: HomepageTopBanner };
});
const WindowsLegacyAppUpsellBanner = Dynamic(async () => {
    const { WindowsLegacyAppUpsellBanner } = await import('#pplx/frontend/apps/ask/upsell-slots/homepage-top-banner/internal/WindowsLegacyAppUpsellBanner.js');
    return { default: WindowsLegacyAppUpsellBanner };
});
export const HomepageTopBannerUpsellSlot = ({ callsite }) => {
    const windowsBannerPlan = useWindowsLegacyAppUpsellBannerPlan(callsite.enabled !== false && !callsite.surface?.hasPrimarySurfaceContent);
    const plan = useHomepageTopBannerUpsellSlotPlan({
        slotId: UPSELL_SLOT_IDS.homepageTopBanner,
        acceptedLocations: UPSELL_SLOT_ACCEPTED_LOCATIONS.homepageTopBanner,
        source: {
            source: 'homepage',
            responseChannel: 'product_banner_information',
            request: {},
        },
        callsite: {
            ...callsite,
            surface: {
                ...callsite.surface,
                // Reserve while Eppo resolves so the backend banner cannot flash before
                // the higher-priority Windows migration banner makes its decision.
                hasPrimarySurfaceContent: callsite.surface?.hasPrimarySurfaceContent || windowsBannerPlan.reservesSlot,
            },
        },
    });
    const lastReadyRenderPropsRef = useRef(null);
    useEffect(() => {
        if (!plan.show) {
            return;
        }
        lastReadyRenderPropsRef.current = plan.render.props;
    }, [plan]);
    const topBannerProps = plan.show
        ? plan.render.props
        : lastReadyRenderPropsRef.current && {
            ...lastReadyRenderPropsRef.current,
            shouldShow: false,
        };
    if (windowsBannerPlan.show) {
        return (_jsx("div", { className: "pointer-events-auto w-full max-w-[632px] pt-3", "data-upsell-slot": "ask.home.top_banner", children: _jsx(WindowsLegacyAppUpsellBanner, { onDismiss: windowsBannerPlan.dismiss, onGetApp: windowsBannerPlan.dismiss }) }));
    }
    if (!topBannerProps) {
        return null;
    }
    return (_jsx("div", { className: "pointer-events-auto flex h-headerHeight items-center", children: _jsx(HomepageTopBanner, { ...topBannerProps }) }));
};
//# sourceMappingURL=HomepageTopBannerUpsellSlot.js.map